import { render, staticRenderFns } from "./PortableGenCard.vue?vue&type=template&id=b23116be"
import script from "./PortableGenCard.vue?vue&type=script&lang=js"
export * from "./PortableGenCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports